'use es6';

import { Record } from 'immutable';
const ChildrenReportRecord = Record({
  reportMap: null,
  totals: null
});
export default ChildrenReportRecord;